const images = {
  logo: require('./logo.svg')
}

export default images
